module.exports = __webpack_public_path__ + "img/0元试用.24ca0602.svg";